<template>
  <div class="content-wrapper intro-quote">
    <div class="d-flex align-items-center full-height justify-content-center">
      <div class="row">
        <div class="col-12" style="text-align: center">
          <h1 class="general-title quote-step">"Simplicity is the ultimate sophistication"</h1>
          <div style="margin-bottom: 100px">Leonardo Da Vinci</div>
          <button class="btn btn-outline-primary" v-on:click="$emit('go-next')">
            Next
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "intro-quote",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  
}
.quote-step {
  font-size: 45px;
  @media (max-width: 767px) {
    font-size: 32px;
  }
}
</style>